<template>
  <form>
    <v-layout
      wrap
    >
      <v-flex xs3>
        <div
          class="text-left"
          style="margin-top: 50px"
        >
          {{ $t('settings.logoAndCarousel.logo') }}
        </div>
      </v-flex>
      <v-flex xs9>
        <select-image
          v-model="imageNew"
          :icon="'mdi-pencil'"
          :isLogo="true"
          :enterpriseID="enterpriseID"
          :color="BGColor"
          :imageOld='Logo'
          :aspectRatio="21/9"
          @input="handleAddLogo"
          style="margin-left:0px;margin-top:15px;"
        />
      <!--canvas ref="apple" width="120" height="120"
                                      v-show="false"
                                      style="margin-top:10px;"
        :style="{ backgroundColor: BGColor }"
      />
      <!--table
                                      v-show="true"
        ref="appleIcon"
        :style="{ backgroundColor: BGColor }"
        style="width: 120px;height: 120px;background-color:red;"
      >
        <tr style="height:120px;">
          <td style="width:120px;vertical-align: middle;">
            <img ref="imageLogo" :src="imageNew ? imageNew : Logo" style="width:120px" />
          </td>
        </tr>
      </table-->
      </v-flex>
      <v-flex xs12>
        <v-divider style="margin: 0px 0 0px 0"/>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-left"
          style="margin-top: 80px"
        >
          {{ $t('settings.logoAndCarousel.carousel') }}
        </div>
      </v-flex>
      <v-flex xs9>
        <carousel
          :limit="3"
          :closed="true"
          :onAddImage="handleAddImageToCarousel"
          :onClearImage="handleDeleteImageToCarousel"
          :enterpriseID="enterpriseID"
          v-model="Carousel"
        />
      </v-flex>
      <v-flex xs12>
        <v-divider style="margin: 0px 0 20px 0"/>
      </v-flex>
      <v-flex xs3>
        <div
          class="text-left"
          style="margin-top: 20px"
        >
          {{ $t('settings.logoAndCarousel.languages') }}
        </div>
      </v-flex>
      <v-flex xs9>
        <v-autocomplete
          v-model="selectedLanguages"
          :items="allLanguages"
          :filter="handleCustomFilter"
          item-text="Name"
          item-value="ID"
          @input="handleChangeSelectedLanguages"
          multiple
        />
      </v-flex>
      <v-flex xs3>
        <div
          class="text-left"
          style="margin-top: 20px"
        >
          {{ $t('settings.logoAndCarousel.defaultLocale') }}
        </div>
      </v-flex>
      <v-flex xs9>
        <v-select
          v-model="selectedDefaultLocale"
          :items="languagesFiltered"
          item-text="Name"
          item-value="ID"
          @input="handleChangeSelectedDefaultLocale"
        />
      </v-flex>
      <v-flex xs12>
        <div
          class="text-right pt-2"
        >
          <v-btn class="mr-4" @click="handleClear">{{ $t('common.cancel') }}</v-btn>
          <v-btn dark :color="enterpriseColor" @click="handleSubmit">{{ $t('common.save') }}</v-btn>
        </div>
      </v-flex>
    </v-layout>
    <!-- <div
      class="text-right pt-2"
    >
      <v-btn class="mr-4" @click="handleClear">{{ $t('common.cancel') }}</v-btn>
      <v-btn dark :color="enterpriseColor" @click="handleSubmit">{{ $t('common.save') }}</v-btn>
    </div> --> 
    <v-snackbar
      top
      right
      v-model="snackbar"
      :timeout="timeout"
      :color="messageColor"
    >
      {{ message }}
      <v-btn
        color="black"
        text
        @click="snackbar = false"
      >
        {{ $t('common.close') }}
      </v-btn>
    </v-snackbar>
  </form>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  import utils from '@/services/utils.js'
  import SelectImage from '@/components/SelectImage'
  import Carousel from './Carousel'
//import VueHtml2Canvas from 'vue-html2canvas'
  export default {
    components: {
      SelectImage,
      Carousel
    },
    props: {
    },
    data: () => ({
      selectedLanguages: [],
      selectedDefaultLocale: null,
      imageNew: null,
      snackbar: false,
      message: false,
      messageColor: 'success',
      timeout: 3000, 
      languagesFiltered: []
    }),
    computed: {
      ...mapState('app',['enterpriseID', 'BGColor', 'Logo', 'Carousel', 'enterpriseColor', 'Languages', 'DefaultLocale']),
      allLanguages () {
        return utils.getAllLanguages()
      }
    },
    watch: {

      'BGColor' () {
        this.prepareAppleIcon()
      },
      'Logo' () {
        this.prepareAppleIcon()
      },
      'imageNew' () {
        this.prepareAppleIcon()
      },
      Languages: {
        handler: function (newValue) {
          this.selectedLanguages = newValue
        },
        deep: true
      },
      DefaultLocale: {
        handler: function (newValue) {
          this.selectedDefaultLocale = newValue
        },
        deep: true
      },
      selectedLanguages: {
        handler: function (newValue) {
          this.languagesFiltered = this.allLanguages.filter(x => newValue.indexOf(x.ID) >= 0)
        },
        deep: true
      },
    },
    mounted () {
      this.selectedLanguages = this.Languages
      this.selectedDefaultLocale = this.DefaultLocale
      this.languagesFiltered = this.allLanguages.filter(x => this.selectedLanguages.indexOf(x.ID) >= 0)
      //this.prepareAppleIcon()
    },
    methods: {
      handleChangeSelectedDefaultLocale () {
        this.$store.state.app.DefaultLocale = this.selectedDefaultLocale
      },
      handleChangeSelectedLanguages () {
        this.$store.state.app.Languages = this.selectedLanguages
      },
      handleAddImageToCarousel (logo) {
        this.$store.state.app.Carousel.push(logo)
      },
      handleDeleteImageToCarousel (image) {
        this.$store.state.app.Carousel = this.$store.state.app.Carousel.filter(x => x !== image)
      },
      handleAddLogo (logo) {
        this.$store.state.app.Logo = logo
      },
      handleCustomFilter (item, queryText) {
        const textOne = item.Name.toLowerCase()
        const searchText = queryText ? queryText.toLowerCase() : ''

        return textOne.indexOf(searchText) > -1
      },
      /*
      prepareAppleIcon () {
        const canvas = this.$refs.apple
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = this.BGColor
        ctx.fillRect(0, 0, 120, 120)
        //const img = this.$refs.imageLogo
        const img = new Image()
        img.origin = 'anonymous'
        img.setAttribute('crossOrigin', 'anonymous')
        const url = this.imageNew ? this.imageNew : this.Logo.replace('http://dtouch', 'https://www.dtouch')
        img.src = url + '?' + new Date().getTime()
        img.onload = function () {
          ctx.drawImage(img, 0, 30, 120, 60)
        }
      },
      */
      async handleSubmit () {
/*
        try {
//        var canvas = document.getElementById("myCanvas");
        const canvas = this.$refs.apple
        //const appleIcon = await this.$html2canvas(canvas, { type: 'dataURL' })

        console.log(canvas.toDataURL())
        }catch (error) {
          console.log(error)
        }
        */
        const body = {
          Logo: this.$store.state.app.Logo,
          Carousel: this.$store.state.app.Carousel,
          Languages: this.selectedLanguages,
          DefaultLocale: this.selectedDefaultLocale
        }
        api.updateItem('enterprises', this.enterpriseID.concat('/logo-and-carousel'), body)
          .then(response => {
            if (!response.data.error) {
              this.message = this.$t('settings.logoAndCarousel.messages.update')
              this.messageColor = 'success'
              this.snackbar = true
            }
          })
          .catch(error => {
            console.log('error', error)
          })
      },
      handleClear () {
        api.getItem('enterprises', false, this.enterpriseID).then(response => {
          this.$store.state.app.Logo = response.Logo
          this.$store.state.app.Carousel = response.Carousel.split(',')
          this.$store.state.app.Languages = response.Languages.split(',')
          this.$store.state.app.DefaultLocale = response.DefaultLocale
          this.selectedLanguages = this.$store.state.app.Languages
          this.selectedDefaultLocale = this.$store.state.app.DefaultLocale
        })
      },
    },
  }
</script>
